import {
  NEW_QUIZ,
  COMPLETE_QUIZ,
  LEADER_BOARD_DETAIL,
} from 'src/constants/routes'
import { INotification, NotificationType } from 'src/api/notifications/types'

export const getNotificationLink = (notification: INotification) => {
  switch (notification.eventType) {
    case NotificationType.QuizNewPublished:
      return NEW_QUIZ.replace(':id', String(notification.quizId))
    case NotificationType.QuizCompletedFriend:
      return NEW_QUIZ.replace(':id', String(notification.quizId))
    case NotificationType.QuizCompletedBothSides:
      return COMPLETE_QUIZ.replace(':id', String(notification.quizId))
    case NotificationType.FriendRequestApproved:
    case NotificationType.FriendRequestApprovedByMe:
      return LEADER_BOARD_DETAIL.replace(
        ':id',
        String(notification.connectionId)
      )
    default:
      return ''
  }
}
